import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import { Params } from 'types';

export const fetchCLOListingService = async (queryParams: Params) => {
  const {
    fields = '*',
    include = '',
    offset = 0,
    limit = 10,
    orderBy = '',
    filter = '',
    extent = '',
    eId = '',
    seed = ''
  } = queryParams;
  const urlBuilder = createUrlBuilder('/clo/organisations');
  if (extent) {
    urlBuilder.addParameter('extent', JSON.stringify(extent));
  }
  if (eId) {
    urlBuilder.addParameter('eId', eId);
  }
  urlBuilder.addParameter('fields', fields);
  urlBuilder.addParameter('include', include);
  urlBuilder.addParameter('filter', filter);
  urlBuilder.addParameter('offset', offset);
  urlBuilder.addParameter('limit', limit);
  urlBuilder.addParameter('order', orderBy);
  if (seed) {
    urlBuilder.addParameter('seed', seed);
  }
  const result =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return result;
};

export const fetchCLODetailsService = async (cloId: number) => {
  const urlBuilder = createUrlBuilder(`/clo/organisations/${cloId}`);
  const result =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return result;
};

export const addCLOEvent = async ({ cloId, eventType }: any) => {
  const payload = { eventType: eventType };
  const urlBuilder = createUrlBuilder(`/clo/organisations/${cloId}/event`);
  return await postRequest(AppService, urlBuilder.toString(), payload);
};

export const addOrRemoveCLOAsFavourite = async ({ cloId, action }: any) => {
  const urlBuilder = createUrlBuilder(`/clo/organisations/${cloId}/favourite`);
  if (action === 'remove') {
    return await deleteRequest(AppService, urlBuilder.toString());
  } else {
    return await postRequest(AppService, urlBuilder.toString());
  }
};

export const hideOrUnhideCLO = async ({ cloId, action }: any) => {
  const urlBuilder = createUrlBuilder(`/clo/organisations/${cloId}/hide`);
  if (action === 'unhide') {
    return await deleteRequest(AppService, urlBuilder.toString());
  } else {
    return await postRequest(AppService, urlBuilder.toString());
  }
};
